import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class preStudentAddressInfo {
      PreStudAddrID :number; 
      StudentID :number;   
      StudentAddress1 :string=""; 
      StudentAddress2 :string="";   
      StudentCity :string="";  
      StudentDistrictID :number=0; 
      StudentPinCode :string="";  
      TahasilID :number=0;  
      StateID :number=0; 
      LocationID :number=0; 
      ForeignAddress :string=""; 
      ForeignCityName :string; 
      ForeignCountryName :string=""; 
      StudentLocalAddress :string="";  
      StudentLocalStateID :number=0;  
      StudentLocalTahsilID :number=0;  
      StudentLocalDistrictID :number=0; 
      StudentLocalCity :string=""; 
      StudentLocalPincode :string=""; 
      StudentLocalLocationID :number=0; 
      CreatedLoginID :number=0;   
      UpdatedLoginID :number=0; 
      DistrictOtherDetl :string=""; 
      StudentLocalAddress2 :string="";  
      PhotoPath :string="";  
      SignPath :string=""; 
      StudentPhoto :string=""; 
      StudentSign :string=""; 
      ImageType :string =""; 
      CorrespondenceAddressCheckbox:boolean=false;
      NationalityFlag:string="";
}
export class preStudentAddressInfoNEW {
  PreStudAddrID :number; 
  StudentID :number;   
  StudentAddress1 :string=""; 
  StudentAddress2 :string="";   
  StudentCity :string="";  
  StudentDistrictID :number=0; 
  StudentPinCode :string="";  
  TahasilID :number=0;  
  StateID :number=0; 
  LocationID :number=0; 
  ForeignAddress :string=""; 
  ForeignCityName :string; 
  ForeignCountryName :string=""; 
  StudentLocalAddress :string="";  
  StudentLocalStateID :number=0;  
  StudentLocalTahsilID :number=0;  
  StudentLocalDistrictID :number=0; 
  StudentLocalCity :string=""; 
  StudentLocalPincode :string=""; 
  StudentLocalLocationID :number=0; 
  CreatedLoginID :number=0;   
  UpdatedLoginID :number=0; 
  DistrictOtherDetl :string=""; 
  StudentLocalAddress2 :string="";  
  PhotoPath :string="";  
  SignPath :string=""; 
  StudentPhoto :string=""; 
  StudentSign :string=""; 
  ImageType :string =""; 
  CorrespondenceAddressCheckbox:boolean=false;
  NationalityFlag:string="";
}
export class CourseType
{
  CourseTypeID:number;
  CourseTypeName: string;  
}
@Injectable({
  providedIn: 'root'
})
export class ContactdetailsService {

  constructor(private dataService: DataAccessService) {
   
   }
   public PreStudentAddressInfoData: ContactdetailsService;
  public save(data) {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'PostInsertPreStudentAddressInfo'; // setting method name from API controller.
    return this.dataService.add<preStudentAddressInfo[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'PostPreStudentAddressInfo'; // setting method name from API controller.
    return this.dataService.add<preStudentAddressInfo[]>(data)
  }
  public GetContactinfo(StudentID) {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'GetPreStudentAddressInfoList?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<preStudentAddressInfo[]>()
  } 

  public GetBasicCountryListWithoutIndia(){
    this.dataService.setControllerName = '/BasicCountry/';
    this.dataService.setMethodName = 'GetBasicCountryListWithoutIndia?CountryID=0'
    return this.dataService.getAll<preStudentAddressInfo[]>()
  }
  public GetBasicCourseTypeList() {
    this.dataService.setControllerName = '/BasicCourseType/';
    this.dataService.setMethodName = 'GetBasicCourseTypeList?CourseTypeID=0';
    return this.dataService.getAll<CourseType[]>()
  }
  public GetInsertCourseType(StudentID,CourseTypeID) {
    this.dataService.setControllerName = '/BasicCourseType/';
    this.dataService.setMethodName = 'GetInsertCourseType?StudentID='+ StudentID + '&CourseTypeID='+ CourseTypeID + '';
    return this.dataService.getAll<CourseType[]>()
  }
  public Getcheckadharnoduplicate(AadharNoID,StudentID) {
    this.dataService.setControllerName = '/BasicCourseType/';
    this.dataService.setMethodName = 'Getcheckadharnoduplicate?AadharNoID='+ AadharNoID + '&StudentID='+StudentID+'';
    return this.dataService.getAll<CourseType[]>()
  }
}
